import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '@environments/environment-urls';

import { SysadminDashboardResponse } from '@core/models/sysadminDashboard.model';

@Injectable({ providedIn: 'root' })
export class SysadminApiService {
  private readonly http = inject(HttpClient);

  public getSysadminDashboard(): Observable<SysadminDashboardResponse> {
    return this.http.get<SysadminDashboardResponse>(`${environment.apiUrl}/user/api/v1/sysadmin/dashboard`);
  }

  public getSysadminAvatar(): Observable<Blob> {
    return this.http.get(`${environment.apiUrl}/user/api/v1/sysadmin/avatar`, { responseType: 'blob' });
  }
}
